import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children, hideChrome = false }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  if (hideChrome) {
    return <div className="min-h-screen bg-[#F4F3F0]">{children}</div>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#F4F3F0]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
